export enum League {
  None = 'None',
  MajorLeagueBaseball = 'MLB', //america

  // others
  ChineseProfessionalBaseballLeague = 'CPBL', //taiwan
  KoreaBaseballOrganization = 'KBO', //korea
  NipponProfessionalBaseball = 'NPB', //japan
}
